<template>
  <div class="redes-view">
    <RedesNavbar />
    <BannerRedes />
     <CategoriasRedes/>
<RedesFqa/>
    <FooterSection />
  </div>
</template>

<script>
import RedesNavbar from '@/components/RedesView/RedesNavbar.vue'
import BannerRedes from '@/components/RedesView/BannerRedes.vue'
import CategoriasRedes from '@/components/RedesView/CategoriasRedes.vue'
import RedesFqa from '@/components/RedesView/RedesFqa.vue'
import FooterSection from '@/components/FooterSection.vue'

export default {
  name: 'RedesView',
  components: {
    RedesNavbar,
    BannerRedes,
CategoriasRedes,
RedesFqa,
    FooterSection,
  },
  mounted() {
    const backBtn = this.$refs.backBtn
    backBtn.style.opacity = '0'
    backBtn.style.transform = 'translateY(40px) scale(0.95)'

    setTimeout(() => {
      backBtn.style.transition = 'all 0.6s ease-out'
      backBtn.style.opacity = '1'
      backBtn.style.transform = 'translateY(0) scale(1)'
    }, 500)

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible')
        }
      })
    }, { threshold: 0.2 })

    const targets = document.querySelectorAll('.fade-in')
    targets.forEach((el, i) => {
      el.style.transitionDelay = `${i * 0.2}s`
      observer.observe(el)
    })
  }
}
</script>

<style scoped>
.redes-view {
  min-height: 100vh;
  font-family: 'Poppins', sans-serif;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

/* Botón de volver */
.service-detail__back {
  align-self: center;
  margin: 2rem 0;
  padding: 0.8rem 1.6rem;
  background-color: #00bcd4;
  color: #fff;
  border-radius: 50px;
  font-weight: bold;
  text-decoration: none;
  box-shadow: 0 0 12px rgba(0, 188, 212, 0.4);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  animation: bounceIn 0.8s ease-out;
}

.service-detail__back:hover {
  transform: scale(1.05);
  box-shadow: 0 0 20px rgba(0, 188, 212, 0.6);
}

/* Animaciones */
.fade-in {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease;
}

.visible {
  opacity: 1 !important;
  transform: translateY(0) !important;
}

/* Bounce efecto */
@keyframes bounceIn {
  0% {
    transform: translateY(60px) scale(0.9);
    opacity: 0;
  }
  60% {
    transform: translateY(-10px) scale(1.05);
    opacity: 1;
  }
  80% {
    transform: translateY(5px) scale(0.98);
  }
  100% {
    transform: translateY(0) scale(1);
  }
}

/* Responsive refinado */
@media (max-width: 480px) {
  .service-detail__back {
    font-size: 0.95rem;
    padding: 0.6rem 1.2rem;
  }
}
</style>
